import { Subject } from 'rxjs';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ReportingService } from '../../services/reporting.service';
import { FileService } from '../../services/file.service';
import { NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../services';
import { Perpetual } from '../../models/perpetual.model';
import { TablefilterMultiplePipe } from '../../shared/pipes/tablefilter-multiple.pipe';
import { NgProgressService } from '../../services/ngProgress.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-web-audit-log',
  templateUrl: './web-audit-log.component.html',
  styleUrls: ['./web-audit-log.component.css']
})
export class WebAuditLogComponent implements OnInit, OnDestroy {

  static WAL_DATE_RANGE = 14;
  title = 'Web Audit Log';

  reportType = '';
  public fromDate: NgbDate;
  public toDate: NgbDate;
  public minToDate: NgbDate;
  public maxToDate: NgbDate;
  public strDateFrom: string;
  public strDateTo: string;

  subTitle = '';
  searchField = '';
  loadContent = false;
  //export excel
  url: string;
  perpetualList : Array<Perpetual>;
  sortedData : Array<Perpetual>;
  filterResultArr: any;
  //ngUnsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();
  selectedType: string;
  hasEmptyFilterResult: boolean = false;

  constructor(
    private router: Router,
    private calendar: NgbCalendar,
    private reportingService: ReportingService,
    private commonService: CommonService,
    private fileService: FileService,
    public ngProgress: NgProgressService
  ) { }

  ngOnInit() {
    const today = this.calendar.getToday();
    this.fromDate = this.minToDate = this.calendar.getNext(today, 'd', -WebAuditLogComponent.WAL_DATE_RANGE);
    this.toDate = this.maxToDate = today;
    this.convertDateFormat();
  }
  
  convertDateFormat(): void {
    this.strDateFrom = this.fromDate.day + '/' + this.fromDate.month + '/' + this.fromDate.year;
    this.strDateTo = this.toDate.day + '/' + this.toDate.month + '/' + this.toDate.year;
  }

  validateDayRanges(btnName: string):boolean {
    const _MS_PER_DAY = 1000 * 60 * 60 * 24;
    const utcFrom = Date.UTC(this.fromDate.year, this.fromDate.month, this.fromDate.day);
    const utcTo = Date.UTC(this.toDate.year, this.toDate.month, this.toDate.day);

    const days = Math.floor((utcTo - utcFrom) / _MS_PER_DAY);

    if (days > 100) {
      $('#' + btnName).showValidator('Report date range can be maximum of 100 days', 'error', 'right');
      return false;
    } else if (days < 1) {
      $('#' + btnName).showValidator('Invalid date range selected', 'error', 'right');
      return false;
    }
    return true;
  }

  filterReports():void {
    this.convertDateFormat();
    const isValid = this.validateDayRanges('btnFilter');
    if(!isValid) return;
  }

  downloadLogs():void {
    const isValid = this.validateDayRanges('btnDownload');
    if(!isValid) return;
    this.ngProgress.start();
    this.commonService.implementToast('Web Audit Log will be downloaded shortly', 'Info');
    this.exportEsdReport();
  }

  exportEsdReport():void {
    this.ngProgress.start();
    //convert dates before calling service methods
    this.convertDateFormat();

    this.reportingService.exportWebAuditLog(this.strDateFrom, this.strDateTo).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: any) => {
          const fileName = `Web_Audit_Log-${this.strDateFrom}-${this.strDateTo}.xlsx`;
          this.fileService.saveAsExcelFile(data, fileName);
          this.ngProgress.done();
          this.commonService.implementToast('Web Audit Log downloaded successfully', 'Success');
      }, (error: any) => {
        if (error?.status == false) {
          this.commonService.implementToast(error.responseMessage, 'Error');
        } else {
          this.commonService.implementToast('Something went wrong', 'Error');
        }
        this.ngProgress.done();
      });
  }
 
  isActive(orderNo: string): boolean {
    return this.router.url.includes(orderNo);
  }

  onChange() {
    this.filterResultArr = new TablefilterMultiplePipe().transform(this.sortedData, ['out_eu_name', 'out_cust_reference', 'out_order_date', 'out_order_no'], this.searchField);
    if (this.filterResultArr.length === 0 && this.searchField !=='') {
      this.hasEmptyFilterResult = true;

    } else {
      this.hasEmptyFilterResult = false;
    }
  }

  onFromDateChange(): void {
    this.minToDate = this.fromDate;
    this.maxToDate = this.toDate = this.calendar.getNext(this.fromDate, 'd', WebAuditLogComponent.WAL_DATE_RANGE);
  }

  filterReset() {
    this.searchField = "";
    this.hasEmptyFilterResult = false;
    this.sortedData = this.perpetualList;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }
  
  close() {
   // $('.page-contents').animate({ scrollLeft: -$('#levelOne').width() }, 400);
    this.router.navigateByUrl('/reporting');
  }

}
